// // import format from "date-fns/format";
// // import getDay from "date-fns/getDay";
// // import parse from "date-fns/parse";
// // import startOfWeek from "date-fns/startOfWeek";

// import './stylecalendar.css'
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";


// import React, { useState, useEffect } from "react";

// import Cookies from "js-cookie";

// import { Circles } from "react-loader-spinner";

// import {
//   Calendar,
//   // dateFnsLocalizer,
//   momentLocalizer,
// } from "react-big-calendar";
// import "react-big-calendar/lib/css/react-big-calendar.css";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// import moment from "moment";
// import "moment-timezone"; // or 'moment-timezone/builds/moment-timezone-with-data[-datarange].js'. See their docs

// import RecordsDashboard from "./RecordsDashboard";

// // Set the IANA time zone you want to use
// moment.tz.setDefault("Nairobi/Kenya");

// // Setup the localizer by providing the moment Object
// // to the correct localizer.
// const localizer = momentLocalizer(moment); // or globalizeLocalizer



// // let events = [

// // ];

// function RecordsCalender() {
//    const [foundErr, setFoundErr] = useState(null);
//   const [isLoading, setIsLoading] = useState(null);

//   const [records, setRecords] = useState([]);

//     const [loading, setLoading] = useState(true);
//     const [profile, setProfile] = useState(null);

//   const [downloadPeriod, setDownloadPeriod] = useState("full");

//   const [customStartDate, setCustomStartDate] = useState(null);
//   const [customEndDate, setCustomEndDate] = useState(new Date());

//   const [newEvent, setNewEvent] = useState({
//   title: "",
//   start: null,
//   end: null,
// });



//   const handleRefreshRecords = () => {
//   fetchRecords();
// };
//   const productColors = {
//   milk: "#3b82f6",     // blue
//   coffee: "#ef4444",   // red
//   'tea leaves': "#10b981",      // green
// };

// const eventStyleGetter = (event) => {
//   return {
//     style: {
//       backgroundColor: event.color,
//       borderRadius: "6px",
//       color: "white",
//       border: "none",
//       padding: "2px",
//     },
//   };
// };





// const calendarEvents = records.map((record) => {
//   const type = (record.producttype || "").toLowerCase();

//   return {
//     id: record.id,
//     title: `${record.weight}kg ${record.producttype}`,
//     start: moment(record.daterecorded).toDate(),
//     end: moment(record.daterecorded).toDate(),
//     allDay: true,
//     color: productColors[type] || "#6b7280",
//   };
// });


//   useEffect(() => {
//     //fetch agents
//     const fetchAll = () => {
//       let adminCookie = Cookies.get("sessioniduser");
//       if (adminCookie.length >= 1) {
//         setIsLoading(true);

//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/getRecords", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               userid: adminCookie,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error("Wrong credentials");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//         .then((data) => {

//   console.log("Calendar API:", data);

//   if (data?.records) {
//     setRecords(data.records);
//   } else {
//     setRecords([]);
//   }

//     // safety check (important)
//     if (data?.profile) {
//       setProfile(data.profile || {});
//       // setRecords(data.records || []);
//     } else {
//       // fallback for unexpected response
//       setProfile({});
//       // setRecords([]);
//     }
//   setFoundErr(null);
//   setIsLoading(false);
// })
//             .catch((err) => {
//               // setFoundErr(err.message);
//               setIsLoading(null);
//               // setFlag(1);
//             });
//         }, 2000);
//       } else {
//         setIsLoading(null);
//       }
//     };

//     fetchAll();
//   }, []);







//   const fetchRecords = () => {
//     let adminCookie = Cookies.get("sessioniduser");
//     if (adminCookie.length >= 1) {
//       setIsLoading(true);

//       setTimeout(() => {
//         fetch("https://api.terraweb.africa/getRecords", {
//           method: "post",
//           headers: { "Content-Type": "application/JSON" },
//           body: JSON.stringify({
//             userid: adminCookie,
//           }),
//         })
//           .then(function (response) {
//             if (response.status === 400) {
//               throw Error("Wrong credentials");
//             }
//             if (response === 500) {
//               throw Error("Could not complete request because of an error");
//             }

//             return response.json();
//           })
//       .then((data) => {

//   console.log("Calendar API:", data);

//   if (data?.records) {
//     setRecords(data.records);
//   } else {
//     setRecords([]);
//   }

  
//     // safety check (important)
//     if (data?.profile) {
//       setProfile(data.profile || {});
//       // setRecords(data.records || []);
//     } else {
//       // fallback for unexpected response
//       setProfile({});
//       // setRecords([]);
//     }

//   setFoundErr(null);
//   setIsLoading(false);
// })
//           .catch((err) => {
//             // setFoundErr(err.message);
//             setIsLoading(null);
//             // setFlag(1);
//           });
//       }, 5000);
//     } else {
//       setIsLoading(null);
//     }
//   };

//   //refresh after add records
//   const refreshRecords = () => {
//     fetchRecords();
    
//   };

//   const getCompanyInitials = (name = "") => {
//   return name
//     .split(" ")
//     .map(w => w[0])
//     .join("")
//     .toUpperCase()
//     .slice(0, 2);
// };

// // working download

// // const handleDownloadTable = async () => {
// //   const doc = new jsPDF();

// //   const filteredRecords = getFilteredRecords();
// //   const currentDate = new Date().toISOString().replace("T", " ").split(".")[0];

// //   const companyName =
// //     filteredRecords?.[0]?.companyname ||
// //     records?.[0]?.companyname ||
// //     "Terraweb";

// //   const initials = getCompanyInitials(companyName);

// //   const getBase64ImageFromUrl = async (url) => {
// //     const res = await fetch(url);
// //     const blob = await res.blob();

// //     return new Promise((resolve) => {
// //       const reader = new FileReader();
// //       reader.onloadend = () => resolve(reader.result);
// //       reader.readAsDataURL(blob);
// //     });
// //   };

// //   const faviconBase64 = await getBase64ImageFromUrl("/img/LOGO-FAVCON.png");

// //   // avatar based on gender, same helper you use in the dashboard header
// //   const avatarUrl = getGenderAvatar(profile?.gender);
// //   const avatarBase64 = await getBase64ImageFromUrl(avatarUrl);

// //   // =========================
// //   // HEADER — USER PROFILE (LEFT)
// //   // =========================
// //   const avatarSize = 16;
// //   const avatarX = 14;
// //   const avatarY = 5;

// //   // circular clip for the avatar
// //   doc.saveGraphicsState();
// //   doc.setFillColor(255, 255, 255);
// //   doc.circle(
// //     avatarX + avatarSize / 2,
// //     avatarY + avatarSize / 2,
// //     avatarSize / 2,
// //     "F"
// //   );
// //   doc.clip();
// //   doc.addImage(avatarBase64, "JPEG", avatarX, avatarY, avatarSize, avatarSize);
// //   doc.restoreGraphicsState();

// //   // thin ring around the avatar for polish
// //   doc.setDrawColor(252, 156, 28);
// //   doc.setLineWidth(0.6);
// //   doc.circle(
// //     avatarX + avatarSize / 2,
// //     avatarY + avatarSize / 2,
// //     avatarSize / 2,
// //     "S"
// //   );

// //   const textX = avatarX + avatarSize + 4;

// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(12);
// //   doc.setTextColor(20, 20, 20);
// //   doc.text(profile?.username || "User", textX, avatarY + 6);

// //   doc.setFont("helvetica", "normal");
// //   doc.setFontSize(9);
// //   doc.setTextColor(100, 100, 100);
// //   doc.text(profile?.company || companyName, textX, avatarY + 11);

// //   const isActive = (profile?.status || "").toLowerCase() === "active";
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(8);
// //   doc.setTextColor(...(isActive ? [22, 101, 52] : [153, 27, 27]));
// //   doc.text(isActive ? "● Active" : "⛔ Suspended", textX, avatarY + 15.5);

// //   // =========================
// //   // HEADER — COMPANY BADGE (RIGHT)
// //   // =========================
// //   const badgeX = 180;
// //   const badgeY = 5;
// //   const badgeSize = 16;

// //   doc.setFillColor(252, 156, 28);
// //   doc.roundedRect(badgeX, badgeY, badgeSize, badgeSize, 3, 3, "F");

// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(18);
// //   doc.setTextColor(255, 255, 255);

// //   const textWidth = doc.getTextWidth(initials);

// //   doc.text(
// //     initials,
// //     badgeX + badgeSize / 2 - textWidth / 2,
// //     badgeY + 11
// //   );

// //   doc.setTextColor(0, 0, 0);

// //   // =========================
// //   // META LINE
// //   // =========================
// //   doc.setFontSize(10);
// //   doc.setFont("helvetica", "bold");
// //   doc.setTextColor(0, 0, 0);
// //   doc.text(`Company: ${companyName}`, 14, 30);
// //   doc.text(`Generated: ${currentDate}`, 14, 36);

// //   // subtle divider under the header block
// //   doc.setDrawColor(230, 230, 230);
// //   doc.setLineWidth(0.3);
// //   doc.line(14, 40, 196, 40);

// //   // =========================
// //   // PRODUCTION KEY / LEGEND
// //   // =========================
// //   const productTotals = {};

// //   filteredRecords.forEach((r) => {
// //     const type = (r.producttype || "").toLowerCase();
// //     const weight = Number(r.weight) || 0;
// //     productTotals[type] = (productTotals[type] || 0) + weight;
// //   });

// //   const legendItems = [
// //     { key: "milk", label: "Milk", color: [37, 99, 235] },
// //     { key: "coffee", label: "Coffee", color: [239, 68, 68] },
// //     { key: "tea leaves", label: "Tea Leaves", color: [34, 197, 94] },
// //   ];

// //   let legendX = 14;
// //   const legendY = 47;

// //   legendItems.forEach((item) => {
// //     const total = productTotals[item.key] || 0;

// //     doc.setFillColor(...item.color);
// //     doc.roundedRect(legendX, legendY - 3.5, 4, 4, 1, 1, "F");

// //     doc.setFont("helvetica", "normal");
// //     doc.setFontSize(9);
// //     doc.setTextColor(0, 0, 0);

// //     const labelText = `${item.label}: ${total.toFixed(2)} kg`;
// //     doc.text(labelText, legendX + 6, legendY);

// //     legendX += doc.getTextWidth(labelText) + 14;
// //   });

// //   doc.setFont("helvetica", "normal");
// //   doc.setFontSize(10);
// //   doc.text(`Total Records: ${filteredRecords?.length || 0}`, 14, 55);

// //   // =========================
// //   // TABLE
// //   // =========================

// //   const tableColumn = [
// //     "ID",
// //     "Farmer ID",
// //     "Product Type",
// //     "Weight",
// //     "Company",
// //     "Full Name",
// //     "Added by",
// //     "Recorded Date",
// //   ];

// //   const tableRows = filteredRecords.map((r) => [
// //     r.id,
// //     r.farmerid,
// //     r.producttype,
// //     r.weight,
// //     r.companyname,
// //     r.fullname,
// //     r.added_by || r.username || "system",
// //     r.daterecorded,
// //   ]);

// //   autoTable(doc, {
// //     head: [tableColumn],
// //     body: tableRows,
// //     startY: 62,
// //     theme: "grid", // <-- draws borders around every cell instead of borderless "plain" theme
// //     styles: {
// //       fontSize: 9,
// //       cellPadding: 3,
// //       textColor: [40, 40, 40],
// //       lineColor: [210, 210, 210], // soft gray borders, not harsh black
// //       lineWidth: 0.15,
// //     },
// //     headStyles: {
// //       fillColor: [252, 156, 28],
// //       textColor: [0, 0, 0],
// //       fontStyle: "bold",
// //       lineColor: [230, 160, 60],
// //       lineWidth: 0.2,
// //     },
// //     alternateRowStyles: {
// //       fillColor: [250, 250, 250], // very light zebra striping, low opacity feel
// //     },
// //     margin: { top: 60, bottom: 25 },

// //     // =========================
// //     // ROW COLOR BY PRODUCT TYPE (now enabled, softened)
// //     // =========================
// //     didParseCell: function (data) {
// //       if (data.section !== "body") return;

// //       const productType = (data.row.raw[2] || "").toString().toLowerCase();

// //       const rowColors = {
// //         milk: [235, 243, 255],       // very light blue tint
// //         coffee: [255, 240, 240],     // very light red tint
// //         "tea leaves": [235, 250, 240], // very light green tint
// //       };

// //       const textColors = {
// //         milk: [30, 64, 175],
// //         coffee: [153, 27, 27],
// //         "tea leaves": [22, 101, 52],
// //       };

// //       const bg = rowColors[productType];
// //       if (bg) {
// //         data.cell.styles.fillColor = bg;
// //       }

// //       if (data.column.index === 2 && textColors[productType]) {
// //         data.cell.styles.textColor = textColors[productType];
// //         data.cell.styles.fontStyle = "bold";
// //       }
// //     },

// //     didDrawPage: function (data) {
// //       const pageCount = doc.internal.getNumberOfPages();
// //       const page = doc.internal.getCurrentPageInfo().pageNumber;

// //       const pageHeight = doc.internal.pageSize.height;
// //       const pageWidth = doc.internal.pageSize.width;

// //       const iconSize = 8;

// //       if (faviconBase64) {
// //         doc.addImage(faviconBase64, "PNG", 14, pageHeight - 16, iconSize, iconSize);
// //       }

// //       doc.setFontSize(9);
// //       doc.setFont("helvetica", "normal");
// //       doc.setTextColor(0, 0, 0);

// //       doc.text(
// //         "Terraweb.africa — Empowering through technology",
// //         25,
// //         pageHeight - 10
// //       );

// //       doc.setFont("helvetica", "bold");
// //       doc.text(
// //         `Page ${page} of ${pageCount}`,
// //         pageWidth - 15,
// //         pageHeight - 10,
// //         { align: "right" }
// //       );
// //     },
// //   });

// //   const safeDate = new Date()
// //     .toISOString()
// //     .replace(/T/, "_")
// //     .replace(/:/g, "-")
// //     .split(".")[0];

// //   const fileName = `${companyName}_farmer_records_${safeDate}.pdf`;

// //   doc.save(fileName);
// // };

// // new with profile

// const getGenderAvatar = (gender) => {
//   switch (gender) {
//     case "female":
//       return "/img/femaleavatar.jpg";
//     case "male":
//       return "/img/maleavatar.jpeg";
//     default:
//       return "/img/maleavatar.png";
//   }
// };

// const handleDownloadTable = async () => {
//   const doc = new jsPDF();

//   const filteredRecords = getFilteredRecords();
//   const currentDate = new Date().toISOString().replace("T", " ").split(".")[0];

//   const companyName =
//     filteredRecords?.[0]?.companyname ||
//     records?.[0]?.companyname ||
//     "Terraweb";

//   const initials = getCompanyInitials(companyName);

//   const getBase64ImageFromUrl = async (url) => {
//     const res = await fetch(url);
//     const blob = await res.blob();

//     return new Promise((resolve) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.readAsDataURL(blob);
//     });
//   };

//   const faviconBase64 = await getBase64ImageFromUrl("/img/LOGO-FAVCON.png");

//   // // avatar based on gender, same helper you use in the dashboard header
//   // const avatarUrl = getGenderAvatar(profile?.gender);
//   // const avatarBase64 = await getBase64ImageFromUrl(avatarUrl);

//   const getBase64FromImageElement = (url) =>
//   new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = "anonymous";
//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext("2d");
//       ctx.drawImage(img, 0, 0);
//       resolve(canvas.toDataURL("image/png"));
//     };
//     img.onerror = (err) => reject(err);
//     img.src = url;
//   });

// // =========================
// // HEADER — USER PROFILE (LEFT)
// // =========================
// const avatarSize = 16;
// const avatarX = 14;
// const avatarY = 5;

// let avatarBase64 = null;
// try {
//   const avatarUrl = getGenderAvatar(profile?.gender);
//   avatarBase64 = await getBase64FromImageElement(avatarUrl);
// } catch (err) {
//   console.warn("Avatar failed to load, skipping image:", err);
// }

// if (avatarBase64) {
//   try {
//     doc.saveGraphicsState();
//     doc.setFillColor(255, 255, 255);
//     doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "F");
//     doc.clip();
//     doc.addImage(avatarBase64, "PNG", avatarX, avatarY, avatarSize, avatarSize);
//   } catch (err) {
//     console.warn("Avatar draw failed:", err);
//   } finally {
//     doc.restoreGraphicsState(); // ALWAYS runs, even if addImage throws
//   }

//   doc.setDrawColor(252, 156, 28);
//   doc.setLineWidth(0.6);
//   doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "S");
// } else {
//   // fallback: colored circle so the layout doesn't look broken without an image
//   doc.setFillColor(200, 200, 200);
//   doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "F");
// }

// const textX = avatarX + avatarSize + 4;

// doc.setFont("helvetica", "bold");
// doc.setFontSize(12);
// doc.setTextColor(20, 20, 20);
// doc.text(profile?.fullname || "", textX, avatarY + 6);

// doc.setFont("helvetica", "normal");
// doc.setFontSize(9);
// doc.setTextColor(100, 100, 100);
// doc.text(profile?.email || "", textX, avatarY + 11);

// const isActive = (profile?.status || "").toLowerCase() === "active";
// doc.setFont("helvetica", "bold");
// doc.setFontSize(8);
// doc.setTextColor(...(isActive ? [22, 101, 52] : [153, 27, 27]));
// doc.text(isActive ? "Active" : "", textX, avatarY + 15.5);

//   // =========================
//   // HEADER — COMPANY BADGE (RIGHT)
//   // =========================
//   const badgeX = 180;
//   const badgeY = 5;
//   const badgeSize = 16;

//   doc.setFillColor(252, 156, 28);
//   doc.roundedRect(badgeX, badgeY, badgeSize, badgeSize, 3, 3, "F");

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(18);
//   doc.setTextColor(255, 255, 255);

//   const textWidth = doc.getTextWidth(initials);

//   doc.text(
//     initials,
//     badgeX + badgeSize / 2 - textWidth / 2,
//     badgeY + 11
//   );

//   doc.setTextColor(0, 0, 0);

//   // =========================
//   // META LINE
//   // =========================
//   doc.setFontSize(10);
//   doc.setFont("helvetica", "bold");
//   doc.setTextColor(0, 0, 0);
//   doc.text(`Company: ${companyName}`, 14, 30);
//   doc.text(`Generated: ${currentDate}`, 14, 36);

//   // subtle divider under the header block
//   doc.setDrawColor(230, 230, 230);
//   doc.setLineWidth(0.3);
//   doc.line(14, 40, 196, 40);

//   // =========================
//   // PRODUCTION KEY / LEGEND
//   // =========================
//   const productTotals = {};

//   filteredRecords.forEach((r) => {
//     const type = (r.producttype || "").toLowerCase();
//     const weight = Number(r.weight) || 0;
//     productTotals[type] = (productTotals[type] || 0) + weight;
//   });

//   const legendItems = [
//     { key: "milk", label: "Milk", color: [37, 99, 235] },
//     { key: "coffee", label: "Coffee", color: [239, 68, 68] },
//     { key: "tea leaves", label: "Tea Leaves", color: [34, 197, 94] },
//   ];

//   let legendX = 14;
//   const legendY = 47;

//   legendItems.forEach((item) => {
//     const total = productTotals[item.key] || 0;

//     doc.setFillColor(...item.color);
//     doc.roundedRect(legendX, legendY - 3.5, 4, 4, 1, 1, "F");

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(9);
//     doc.setTextColor(0, 0, 0);

//     const labelText = `${item.label}: ${total.toFixed(2)} kg`;
//     doc.text(labelText, legendX + 6, legendY);

//     legendX += doc.getTextWidth(labelText) + 14;
//   });

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(10);
//   doc.text(`Total Records: ${filteredRecords?.length || 0}`, 14, 55);

//   // =========================
//   // TABLE
//   // =========================

//   const tableColumn = [
//     "ID",
//     "Farmer ID",
//     "Product Type",
//     "Weight",
//     "Company",
//     "Full Name",
//     "Added by",
//     "Recorded Date",
//   ];

//   const tableRows = filteredRecords.map((r) => [
//     r.id,
//     r.farmerid,
//     r.producttype,
//     r.weight,
//     r.companyname,
//     r.fullname,
//     r.added_by || r.username || "system",
//     r.daterecorded,
//   ]);

//   autoTable(doc, {
//     head: [tableColumn],
//     body: tableRows,
//     startY: 62,
//     theme: "grid", // <-- draws borders around every cell instead of borderless "plain" theme
//     styles: {
//       fontSize: 9,
//       cellPadding: 3,
//       textColor: [40, 40, 40],
//       lineColor: [210, 210, 210], // soft gray borders, not harsh black
//       lineWidth: 0.15,
//     },
//     headStyles: {
//       fillColor: [252, 156, 28],
//       textColor: [0, 0, 0],
//       fontStyle: "bold",
//       lineColor: [230, 160, 60],
//       lineWidth: 0.2,
//     },
//     alternateRowStyles: {
//       fillColor: [250, 250, 250], // very light zebra striping, low opacity feel
//     },
//     margin: { top: 60, bottom: 25 },

//     // =========================
//     // ROW COLOR BY PRODUCT TYPE (now enabled, softened)
//     // =========================
//     didParseCell: function (data) {
//       if (data.section !== "body") return;

//       const productType = (data.row.raw[2] || "").toString().toLowerCase();

//       const rowColors = {
//         milk: [235, 243, 255],       // very light blue tint
//         coffee: [255, 240, 240],     // very light red tint
//         "tea leaves": [235, 250, 240], // very light green tint
//       };

//       const textColors = {
//         milk: [30, 64, 175],
//         coffee: [153, 27, 27],
//         "tea leaves": [22, 101, 52],
//       };

//       const bg = rowColors[productType];
//       if (bg) {
//         data.cell.styles.fillColor = bg;
//       }

//       if (data.column.index === 2 && textColors[productType]) {
//         data.cell.styles.textColor = textColors[productType];
//         data.cell.styles.fontStyle = "bold";
//       }
//     },

//     didDrawPage: function (data) {
//       const pageCount = doc.internal.getNumberOfPages();
//       const page = doc.internal.getCurrentPageInfo().pageNumber;

//       const pageHeight = doc.internal.pageSize.height;
//       const pageWidth = doc.internal.pageSize.width;

//       const iconSize = 8;

//       if (faviconBase64) {
//         doc.addImage(faviconBase64, "PNG", 14, pageHeight - 16, iconSize, iconSize);
//       }

//       doc.setFontSize(9);
//       doc.setFont("helvetica", "normal");
//       doc.setTextColor(0, 0, 0);

//       doc.text(
//         "Terraweb.africa — Empowering through technology",
//         25,
//         pageHeight - 10
//       );

//       doc.setFont("helvetica", "bold");
//       doc.text(
//         `Page ${page} of ${pageCount}`,
//         pageWidth - 15,
//         pageHeight - 10,
//         { align: "right" }
//       );
//     },
//   });

//   const safeDate = new Date()
//     .toISOString()
//     .replace(/T/, "_")
//     .replace(/:/g, "-")
//     .split(".")[0];

//   const fileName = `${companyName}_farmer_records_${safeDate}.pdf`;

//   doc.save(fileName);
// };

//   const getFilteredRecords = () => {
//   const now = new Date();

//   if (downloadPeriod === "full") return records;

//   if (downloadPeriod === "month") {
//     return records.filter((r) => {
//       const d = new Date(r.daterecorded);
//       return (
//         d.getMonth() === now.getMonth() &&
//         d.getFullYear() === now.getFullYear()
//       );
//     });
//   }

//   if (downloadPeriod === "custom") {
//     if (!customStartDate || !customEndDate) return [];

//     return records.filter((r) => {
//       const d = new Date(r.daterecorded);
//       // return (
//       //   d >= customStartDate &&
//       //   d <= new Date(customEndDate.setHours(23, 59, 59, 999))
//       // );
//       const endDate = new Date(customEndDate);
// endDate.setHours(23, 59, 59, 999);

// return (
//   d >= customStartDate &&
//   d <= endDate
// );
//     });
//   }

//   return records;
// };

// // const monthlyTotals = records.reduce((acc, r) => {
// //   const month = new Date(r.daterecorded).getMonth();
// //   acc[month] = (acc[month] || 0) + parseFloat(r.weight || 0);
// //   return acc;
// // }, {});

// const monthlyTotals = records.reduce((acc, r) => {
//   const date = new Date(r.daterecorded);
//   const key = `${date.getFullYear()}-${date.getMonth()}`; // e.g. "2026-0"
//   acc[key] = (acc[key] || 0) + parseFloat(r.weight || 0);
//   return acc;
// }, {});


//   return (
//     <div className="Apppp bg-white pa4 mt6 w-80-l center">
//       {/* PAGE HEADER */}


//       {/* FILTER + ACTIONS SECTION */}
//       <div className="bg-near-white br4 shadow-2 pa4 mb1">
        
  
//         {/* stats section */}

//         <RecordsDashboard />


//  {/* LOADER */}
//             {isLoading ? (
//               <div className="mt3">
//                 <Circles
//                   type="Oval"
//                   color="#1b1b1b"
//                   height={40}
//                   width={40}
//                 />
//               </div>
//             ) : null}

//             {/* ERROR */}
//             {foundErr ? (
//               <label className="db red mt3 fw6">
//                 {foundErr}
//               </label>
//             ) : null}

//       </div>




// {/* <div className="flex flex-wrap-ns justify-center mb0 overflow-x-auto">
//   {Object.entries(monthlyTotals).map(([month, total]) => (
//     <div
//       key={month}
//       className="bg-white shadow-1 br3 pa3 ma2 tc flex-shrink-0"
//       style={{ minWidth: "140px" }}
//     >
//       <p><b>Total Monthly Records</b></p>
//       <div className="f6 gray">
//         {moment().month(month).format("MMMM")}
//       </div>
//       <div className="f3 fw6 green">
//         {Number(total).toFixed(2)} kg
//       </div>
//     </div>
//   ))}
// </div> */}

// <div className="flex flex-wrap-ns justify-center mb0 overflow-x-auto">
//   {Object.entries(monthlyTotals).map(([key, total]) => {
//     const [year, monthIndex] = key.split("-");
//     return (
//       <div
//         key={key}
//         className="bg-white shadow-1 br3 pa3 ma2 tc flex-shrink-0"
//         style={{ minWidth: "140px" }}
//       >
//         <p><b>Total Monthly Records</b></p>
//         <div className="f6 gray">
//           {moment().month(Number(monthIndex)).format("MMMM")} {year}
//         </div>
//         <div className="f3 fw6 green">
//           {Number(total).toFixed(2)} kg
//         </div>
//       </div>
//     );
//   })}
// </div>

// <div className="overflow-x-auto">
//   <div className="mw-none" style={{ minWidth: "950px" }}>

  
//       <Calendar
//   localizer={localizer}
//   // events={events}
//     events={calendarEvents}
//   startAccessor="start"
//   endAccessor="end"
//   eventPropGetter={eventStyleGetter}
//   style={{
//     height: 550,
//     marginTop: "3px",
//     backgroundColor: "white",
//     padding: "10px",
//     borderRadius: "12px",
//   }}
// />
// </div>
// </div>
//       <div className="bg-near-white br4 shadow-2 pa4 mb5">


//  {/* TOP GRID */}
       
  
//         {/* DOWNLOAD SECTION */}
//         <div className="flex flex-column flex-row-l items-start items-end-l justify-between">

//           {/* LEFT SIDE */}
//           <div className="w-100 w-70-l">

//             <h3 className="f4 fw6 near-black ma0 mb3">
//               Download Farmer Records
//             </h3>

//             <div className="flex flex-column flex-row-l flex-wrap items-start">

//               {/* PERIOD SELECT */}
//               <div className="mr3 mb3">
//                 <label className="db mb2 fw6 gray f6">
//                   Export Period
//                 </label>

//                 <select
//                   className="
//               pa2
//               br3
//               ba
//               b--light-silver
//               bg-white
//               dark-gray
//               outline-0
//               w5
//             "
//                   value={downloadPeriod}
//                   onChange={(e) =>
//                     setDownloadPeriod(e.target.value)
//                   }
//                 >

//                   <option value="full">
//                     Full Records
//                   </option>

//                   <option value="month">
//   Total Monthly Records
// </option>

//                   <option value="custom">
//                     Custom Range
//                   </option>
//                 </select>
//               </div>

//               {/* CUSTOM DATES */}
//               {downloadPeriod === "custom" && (
//                 <>
//                   {/* FROM */}
//                   <div className="mr3 mb3">
//                     <label className="db mb2 fw6 gray f6">
//                       From
//                     </label>

//                     <DatePicker
//                       selected={customStartDate}
//                       onChange={(date) =>
//                         setCustomStartDate(date)
//                       }
//                       placeholderText="Start Date"
//                       className="
//                   pa2
//                   br3
//                   ba
//                   b--light-silver
//                   bg-white
//                   dark-gray
//                   outline-0
//                   w5
//                 "
//                     />
//                   </div>

//                   {/* TO */}
//                   <div className="mr3 mb3">
//                     <label className="db mb2 fw6 gray f6">
//                       To
//                     </label>

//                     <DatePicker
//                       selected={customEndDate}
//                       onChange={(date) =>
//                         setCustomEndDate(date)
//                       }
//                       placeholderText="End Date"
//                       className="
//                   pa2
//                   br3
//                   ba
//                   b--light-silver
//                   bg-white
//                   dark-gray
//                   outline-0
//                   w5
//                 "
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* DOWNLOAD BUTTON */}
//           <div className="mt4 mt0-l">
//             <button
//               onClick={handleDownloadTable}
//               className="
//           pointer
//           bn
//           br-pill
//           white
//           bg-dark-green
//           hover-bg-green
//           pa3
//           ph4
//           fw6
//           shadow-1
//           dim
//           transition
//         "
//             >
//               ⬇ Download PDF
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default RecordsCalender;

// function generateMockRecordsMultiMonth(monthsBack = 14) {
//   const types = ["milk", "coffee", "tea leaves"];
//   const mock = [];
//   let id = 2000;

//   for (let m = monthsBack; m >= 0; m--) {
//     const date = new Date();
//     date.setMonth(date.getMonth() - m);
//     date.setDate(Math.floor(Math.random() * 27) + 1); // random day in month

//     // a few records per month so totals aren't just one entry
//     for (let j = 0; j < 3; j++) {
//       const type = types[Math.floor(Math.random() * types.length)];
//       mock.push({
//         id: id++,
//         farmerid: "GA012",
//         producttype: type,
//         weight: String(Math.floor(Math.random() * 50) + 5),
//         companyname: "Gatamura Dairy",
//         fullname: "Vin User",
//         daterecorded: date.toISOString(),
//         status: "null",
//         approved_status: Math.random() > 0.2 ? "approved" : "pending",
//         date_approved: date.toISOString(),
//         edited_by: "Victor_e4HOsh",
//         date_modified: date.toISOString(),
//         username: "Vinuser",
//         gender: "female",
//         company: "Gatamura Dairy",
//       });
//     }
//   }

//   return mock;
// }



// new with good layout
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import React, { useState, useEffect } from "react";

import Cookies from "js-cookie";

import { Circles } from "react-loader-spinner";

import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./stylecalendar.css";


import moment from "moment";
import "moment-timezone";

import RecordsDashboard from "./RecordsDashboard";

// Valid IANA zone (was "Nairobi/Kenya", which moment ignores)
moment.tz.setDefault("Africa/Nairobi");

const localizer = momentLocalizer(moment);

const productColors = {
  milk: "#3b82f6", // blue
  coffee: "#ef4444", // red
  "tea leaves": "#10b981", // green
};

const eventStyleGetter = (event) => ({
  style: {
    backgroundColor: event.color,
    borderRadius: "6px",
    color: "white",
    border: "none",
    padding: "2px",
  },
});

// Phone shows "20kg" in the product colour; desktop shows "20kg milk"
const EventLabel = ({ event }) => (
  <span className="rc-ev">
    <b>{event.weight}kg</b>
    <span className="rc-ev-type"> {event.type}</span>
  </span>
);

const getGenderAvatar = (gender) => {
  switch (gender) {
    case "female":
      return "/img/femaleavatar.jpg";
    case "male":
      return "/img/maleavatar.jpeg";
    default:
      return "/img/maleavatar.png";
  }
};

const getCompanyInitials = (name = "") =>
  name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

function RecordsCalender() {
  const [foundErr, setFoundErr] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const [records, setRecords] = useState([]);
  const [profile, setProfile] = useState(null);

  const [downloadPeriod, setDownloadPeriod] = useState("full");
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(new Date());

  const calendarEvents = records.map((record) => {
    const type = (record.producttype || "").toLowerCase();

    return {
      id: record.id,
      title: `${record.weight}kg ${record.producttype}`,
      weight: record.weight,
      type: record.producttype,
      start: moment(record.daterecorded).toDate(),
      end: moment(record.daterecorded).toDate(),
      allDay: true,
      color: productColors[type] || "#6b7280",
    };
  });

  // load records
  useEffect(() => {
    const adminCookie = Cookies.get("sessioniduser");

    if (!adminCookie) {
      setIsLoading(null);
      return;
    }

    setIsLoading(true);

    const timer = setTimeout(() => {
      fetch("https://api.terraweb.africa/getRecords", {
        method: "post",
        headers: { "Content-Type": "application/JSON" },
        body: JSON.stringify({ userid: adminCookie }),
      })
        .then((response) => {
          if (response.status === 400) {
            throw Error("Wrong credentials");
          }
          if (response.status === 500) {
            throw Error("Could not complete request because of an error");
          }
          return response.json();
        })
        .then((data) => {
          setRecords(data?.records || []);
          setProfile(data?.profile || {});
          setFoundErr(null);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(null);
        });
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // =========================
  // PDF DOWNLOAD
  // =========================
  const getFilteredRecords = () => {
    const now = new Date();

    if (downloadPeriod === "full") return records;

    if (downloadPeriod === "month") {
      return records.filter((r) => {
        const d = new Date(r.daterecorded);
        return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
      });
    }

    if (downloadPeriod === "custom") {
      if (!customStartDate || !customEndDate) return [];

      return records.filter((r) => {
        const d = new Date(r.daterecorded);
        const endDate = new Date(customEndDate);
        endDate.setHours(23, 59, 59, 999);

        return d >= customStartDate && d <= endDate;
      });
    }

    return records;
  };

  // const handleDownloadTable = async () => {
  //   const doc = new jsPDF();

  //   const filteredRecords = getFilteredRecords();
  //   const currentDate = new Date().toISOString().replace("T", " ").split(".")[0];

  //   const companyName =
  //     filteredRecords?.[0]?.companyname || records?.[0]?.companyname || "Terraweb";

  //   const initials = getCompanyInitials(companyName);

  //   const getBase64ImageFromUrl = async (url) => {
  //     const res = await fetch(url);
  //     const blob = await res.blob();

  //     return new Promise((resolve) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => resolve(reader.result);
  //       reader.readAsDataURL(blob);
  //     });
  //   };

  //   const faviconBase64 = await getBase64ImageFromUrl("/img/LOGO-FAVCON.png");

  //   const getBase64FromImageElement = (url) =>
  //     new Promise((resolve, reject) => {
  //       const img = new Image();
  //       img.crossOrigin = "anonymous";
  //       img.onload = () => {
  //         const canvas = document.createElement("canvas");
  //         canvas.width = img.width;
  //         canvas.height = img.height;
  //         const ctx = canvas.getContext("2d");
  //         ctx.drawImage(img, 0, 0);
  //         resolve(canvas.toDataURL("image/png"));
  //       };
  //       img.onerror = (err) => reject(err);
  //       img.src = url;
  //     });

  //   // =========================
  //   // HEADER: USER PROFILE (LEFT)
  //   // =========================
  //   const avatarSize = 16;
  //   const avatarX = 14;
  //   const avatarY = 5;

  //   let avatarBase64 = null;
  //   try {
  //     const avatarUrl = getGenderAvatar(profile?.gender);
  //     avatarBase64 = await getBase64FromImageElement(avatarUrl);
  //   } catch (err) {
  //     console.warn("Avatar failed to load, skipping image:", err);
  //   }

  //   if (avatarBase64) {
  //     try {
  //       doc.saveGraphicsState();
  //       doc.setFillColor(255, 255, 255);
  //       doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "F");
  //       doc.clip();
  //       doc.addImage(avatarBase64, "PNG", avatarX, avatarY, avatarSize, avatarSize);
  //     } catch (err) {
  //       console.warn("Avatar draw failed:", err);
  //     } finally {
  //       doc.restoreGraphicsState(); // ALWAYS runs, even if addImage throws
  //     }

  //     doc.setDrawColor(252, 156, 28);
  //     doc.setLineWidth(0.6);
  //     doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "S");
  //   } else {
  //     // fallback: grey circle so the layout doesn't look broken without an image
  //     doc.setFillColor(200, 200, 200);
  //     doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "F");
  //   }

  //   const textX = avatarX + avatarSize + 4;

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(12);
  //   doc.setTextColor(20, 20, 20);
  //   doc.text(profile?.fullname || "", textX, avatarY + 6);

  //   doc.setFont("helvetica", "normal");
  //   doc.setFontSize(9);
  //   doc.setTextColor(100, 100, 100);
  //   doc.text(profile?.email || "", textX, avatarY + 11);

  //   const isActive = (profile?.status || "").toLowerCase() === "active";
  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(8);
  //   doc.setTextColor(...(isActive ? [22, 101, 52] : [153, 27, 27]));
  //   doc.text(isActive ? "Active" : "", textX, avatarY + 15.5);

  //   // =========================
  //   // HEADER: COMPANY BADGE (RIGHT)
  //   // =========================
  //   const badgeX = 180;
  //   const badgeY = 5;
  //   const badgeSize = 16;

  //   doc.setFillColor(252, 156, 28);
  //   doc.roundedRect(badgeX, badgeY, badgeSize, badgeSize, 3, 3, "F");

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(18);
  //   doc.setTextColor(255, 255, 255);

  //   const textWidth = doc.getTextWidth(initials);

  //   doc.text(initials, badgeX + badgeSize / 2 - textWidth / 2, badgeY + 11);

  //   doc.setTextColor(0, 0, 0);

  //   // =========================
  //   // META LINE
  //   // =========================
  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "bold");
  //   doc.setTextColor(0, 0, 0);
  //   doc.text(`Company: ${companyName}`, 14, 30);
  //   doc.text(`Generated: ${currentDate}`, 14, 36);

  //   // subtle divider under the header block
  //   doc.setDrawColor(230, 230, 230);
  //   doc.setLineWidth(0.3);
  //   doc.line(14, 40, 196, 40);

  //   // =========================
  //   // PRODUCTION KEY / LEGEND
  //   // =========================
  //   const productTotals = {};

  //   filteredRecords.forEach((r) => {
  //     const type = (r.producttype || "").toLowerCase();
  //     const weight = Number(r.weight) || 0;
  //     productTotals[type] = (productTotals[type] || 0) + weight;
  //   });

  //   const legendItems = [
  //     { key: "milk", label: "Milk", color: [37, 99, 235] },
  //     { key: "coffee", label: "Coffee", color: [239, 68, 68] },
  //     { key: "tea leaves", label: "Tea Leaves", color: [34, 197, 94] },
  //   ];

  //   let legendX = 14;
  //   const legendY = 47;

  //   legendItems.forEach((item) => {
  //     const total = productTotals[item.key] || 0;

  //     doc.setFillColor(...item.color);
  //     doc.roundedRect(legendX, legendY - 3.5, 4, 4, 1, 1, "F");

  //     doc.setFont("helvetica", "normal");
  //     doc.setFontSize(9);
  //     doc.setTextColor(0, 0, 0);

  //     const labelText = `${item.label}: ${total.toFixed(2)} kg`;
  //     doc.text(labelText, legendX + 6, legendY);

  //     legendX += doc.getTextWidth(labelText) + 14;
  //   });

  //   doc.setFont("helvetica", "normal");
  //   doc.setFontSize(10);
  //   doc.text(`Total Records: ${filteredRecords?.length || 0}`, 14, 55);

  //   // =========================
  //   // TABLE
  //   // =========================
  //   const tableColumn = [
  //     "ID",
  //     "Farmer ID",
  //     "Product Type",
  //     "Weight",
  //     "Company",
  //     "Full Name",
  //     "Added by",
  //     "Recorded Date",
  //   ];

  //   const tableRows = filteredRecords.map((r) => [
  //     r.id,
  //     r.farmerid,
  //     r.producttype,
  //     r.weight,
  //     r.companyname,
  //     r.fullname,
  //     r.added_by || r.username || "system",
  //     r.daterecorded,
  //   ]);

  //   autoTable(doc, {
  //     head: [tableColumn],
  //     body: tableRows,
  //     startY: 62,
  //     theme: "grid",
  //     styles: {
  //       fontSize: 9,
  //       cellPadding: 3,
  //       textColor: [40, 40, 40],
  //       lineColor: [210, 210, 210],
  //       lineWidth: 0.15,
  //     },
  //     headStyles: {
  //       fillColor: [252, 156, 28],
  //       textColor: [0, 0, 0],
  //       fontStyle: "bold",
  //       lineColor: [230, 160, 60],
  //       lineWidth: 0.2,
  //     },
  //     alternateRowStyles: {
  //       fillColor: [250, 250, 250],
  //     },
  //     margin: { top: 60, bottom: 25 },

  //     // row colour by product type
  //     didParseCell: function (data) {
  //       if (data.section !== "body") return;

  //       const productType = (data.row.raw[2] || "").toString().toLowerCase();

  //       const rowColors = {
  //         milk: [235, 243, 255],
  //         coffee: [255, 240, 240],
  //         "tea leaves": [235, 250, 240],
  //       };

  //       const textColors = {
  //         milk: [30, 64, 175],
  //         coffee: [153, 27, 27],
  //         "tea leaves": [22, 101, 52],
  //       };

  //       const bg = rowColors[productType];
  //       if (bg) {
  //         data.cell.styles.fillColor = bg;
  //       }

  //       if (data.column.index === 2 && textColors[productType]) {
  //         data.cell.styles.textColor = textColors[productType];
  //         data.cell.styles.fontStyle = "bold";
  //       }
  //     },

  //     didDrawPage: function () {
  //       const pageCount = doc.internal.getNumberOfPages();
  //       const page = doc.internal.getCurrentPageInfo().pageNumber;

  //       const pageHeight = doc.internal.pageSize.height;
  //       const pageWidth = doc.internal.pageSize.width;

  //       const iconSize = 8;

  //       if (faviconBase64) {
  //         doc.addImage(faviconBase64, "PNG", 14, pageHeight - 16, iconSize, iconSize);
  //       }

  //       doc.setFontSize(9);
  //       doc.setFont("helvetica", "normal");
  //       doc.setTextColor(0, 0, 0);

  //       doc.text("Terraweb.africa — Empowering through technology", 25, pageHeight - 10);

  //       doc.setFont("helvetica", "bold");
  //       doc.text(`Page ${page} of ${pageCount}`, pageWidth - 15, pageHeight - 10, {
  //         align: "right",
  //       });
  //     },
  //   });

  //   const safeDate = new Date()
  //     .toISOString()
  //     .replace(/T/, "_")
  //     .replace(/:/g, "-")
  //     .split(".")[0];

  //   doc.save(`${companyName}_farmer_records_${safeDate}.pdf`);
  // };

  
  const handleDownloadTable = async () => {
  // Respect the Export Period picker (full / month / custom), newest first
  const rows = [...getFilteredRecords()].sort(
    (a, b) => new Date(b.daterecorded) - new Date(a.daterecorded)
  );

  if (!rows.length) {
    setFoundErr("No records found for the selected period.");
    return;
  }
  setFoundErr(null);

  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginX = 14;

  const BRAND = [252, 156, 28];
  const DARK = [33, 37, 41];
  const MUTED = [110, 117, 125];

  const farmerName = profile?.fullname || rows[0]?.fullname || "Farmer";
  const farmerId = rows[0]?.farmerid || "";
  const companyName = profile?.company || rows[0]?.companyname || "Terraweb";
  const initials = getCompanyInitials(companyName);

  const fmt = (d) => moment(d).format("DD MMM YYYY, HH:mm");
  const generatedOn = moment().format("DD MMM YYYY, HH:mm");

  const periodLabel =
    downloadPeriod === "month"
      ? moment().format("MMMM YYYY")
      : downloadPeriod === "custom"
      ? `${moment(customStartDate).format("DD MMM YYYY")} to ${moment(
          customEndDate
        ).format("DD MMM YYYY")}`
      : "All records";

  // Totals per product (for the summary strip and the footer row)
  const productTotals = {};
  let grandTotal = 0;
  rows.forEach((r) => {
    const type = (r.producttype || "other").toLowerCase();
    const w = Number(r.weight) || 0;
    productTotals[type] = (productTotals[type] || 0) + w;
    grandTotal += w;
  });

  // Logo for the footer; never blocks the download
  const getBase64ImageFromUrl = async (url) => {
    try {
      const res = await fetch(url);
      if (!res.ok) return null;
      const blob = await res.blob();
      return await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      });
    } catch {
      return null;
    }
  };
  const faviconBase64 = await getBase64ImageFromUrl("/img/LOGO-FAVCON.png");

  const HEADER_HEIGHT = 42;
  const TABLE_START_Y = HEADER_HEIGHT + 12; // room for the summary strip

  // Header: drawn on every page
  const drawHeader = () => {
    // Company badge
    const badge = 16;
    doc.setFillColor(...BRAND);
    doc.roundedRect(marginX, 8, badge, badge, 3, 3, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.text(initials, marginX + badge / 2, 18.5, { align: "center" });

    // Company name + report title
    doc.setFontSize(15);
    doc.setTextColor(...DARK);
    doc.text(companyName, marginX + badge + 5, 15);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(...MUTED);
    doc.text("Farmer Records Statement", marginX + badge + 5, 21);

    // Period (right side)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(...DARK);
    doc.text(periodLabel, pageWidth - marginX, 14, { align: "right" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.setTextColor(...MUTED);
    doc.text(`Generated: ${generatedOn}`, pageWidth - marginX, 20, {
      align: "right",
    });

    // Divider
    doc.setDrawColor(...BRAND);
    doc.setLineWidth(0.8);
    doc.line(marginX, 28, pageWidth - marginX, 28);

    // Farmer line
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(...DARK);
    doc.text(`Farmer: ${farmerName}`, marginX, 35);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...MUTED);
    doc.text(
      [farmerId && `Farmer ID: ${farmerId}`, `${rows.length} records`]
        .filter(Boolean)
        .join("   |   "),
      pageWidth - marginX,
      35,
      { align: "right" }
    );
  };

  // Product totals strip (first page only)
  const drawSummary = () => {
    let x = marginX;
    const y = HEADER_HEIGHT + 6;
    doc.setFontSize(9);
    Object.entries(productTotals).forEach(([type, total]) => {
      doc.setFillColor(productColors[type] || "#6b7280");
      doc.roundedRect(x, y - 3.5, 4, 4, 1, 1, "F");
      doc.setFont("helvetica", "normal");
      doc.setTextColor(...DARK);
      const label = `${type.replace(/\b\w/g, (c) => c.toUpperCase())}: ${total.toFixed(2)} kg`;
      doc.text(label, x + 6, y);
      x += doc.getTextWidth(label) + 16;
    });
  };

  const body = rows.map((r) => [
    r.id ?? "-",
    fmt(r.daterecorded),
    r.producttype || "-",
    Number(r.weight || 0).toFixed(2),
    r.added_by_name || "-",
    r.approved_status === "approved"
      ? "Approved"
      : r.approved_status
      ? "Pending"
      : "-",
  ]);

  autoTable(doc, {
    head: [["ID", "Recorded Date", "Product", "Weight (kg)", "Added by", "Status"]],
    body,
    foot: [["", "", "Total", grandTotal.toFixed(2), "", ""]],
    showFoot: "lastPage",
    startY: TABLE_START_Y,
    margin: { top: HEADER_HEIGHT, left: marginX, right: marginX, bottom: 18 },
    theme: "grid",
    styles: {
      font: "helvetica",
      fontSize: 9,
      textColor: DARK,
      cellPadding: { top: 2.8, bottom: 2.8, left: 3, right: 3 },
      lineColor: [225, 228, 232],
      lineWidth: 0.2,
      valign: "middle",
    },
    headStyles: { fillColor: BRAND, textColor: 255, fontStyle: "bold" },
    footStyles: { fillColor: [245, 245, 245], textColor: DARK, fontStyle: "bold" },
    alternateRowStyles: { fillColor: [250, 247, 242] },
    columnStyles: {
      0: { cellWidth: 20, halign: "center" },
      1: { cellWidth: 50 },
      2: { cellWidth: "auto" },
      3: { cellWidth: 36, halign: "right" },
      4: { cellWidth: 55 },
      5: { cellWidth: 30, halign: "center" },
    },
    didParseCell: (data) => {
      if (data.section !== "body") return;
      // Colour the product name to match the calendar
      if (data.column.index === 2) {
        const c = productColors[String(data.cell.raw).toLowerCase()];
        if (c) {
          data.cell.styles.textColor = c;
          data.cell.styles.fontStyle = "bold";
        }
      }
      // Status colours
      if (data.column.index === 5) {
        if (data.cell.raw === "Approved") data.cell.styles.textColor = [25, 135, 84];
        else if (data.cell.raw === "Pending") data.cell.styles.textColor = [200, 120, 0];
      }
    },
    didDrawPage: () => {
      drawHeader();
      if (doc.internal.getCurrentPageInfo().pageNumber === 1) drawSummary();
    },
  });

  // Footer after all pages exist, so "Page X of Y" is correct
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setDrawColor(225, 228, 232);
    doc.setLineWidth(0.3);
    doc.line(marginX, pageHeight - 15, pageWidth - marginX, pageHeight - 15);

    let textX = marginX;
    if (faviconBase64) {
      doc.addImage(faviconBase64, "PNG", marginX, pageHeight - 13, 7, 7);
      textX = marginX + 10;
    }
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(...MUTED);
    doc.text(
      "Terraweb.africa | Empowering farmers through technology",
      textX,
      pageHeight - 8.5
    );
    doc.setFont("helvetica", "bold");
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - marginX, pageHeight - 8.5, {
      align: "right",
    });
  }

  const safeName = String(farmerName).replace(/[^a-z0-9]+/gi, "_");
  doc.save(`${safeName}_records_${moment().format("YYYY-MM-DD")}.pdf`);
};
  
  // totals per month, keyed "year-monthIndex" (e.g. "2026-0")
  const monthlyTotals = records.reduce((acc, r) => {
    const date = new Date(r.daterecorded);
    const key = `${date.getFullYear()}-${date.getMonth()}`;
    acc[key] = (acc[key] || 0) + parseFloat(r.weight || 0);
    return acc;
  }, {});

  return (
    <div className="Apppp bg-white pa1 pa4-ns mt5 mt5-ns w-100 w-80-l center">
      {/* STATS / CHART */}
      <div className="bg-near-white br3 br4-ns shadow-2 pa2 pa4-ns mb1">
        <RecordsDashboard />

        {/* LOADER */}
        {isLoading ? (
          <div className="mt2">
            <Circles type="Oval" color="#1b1b1b" height={40} width={40} />
          </div>
        ) : null}

        {/* ERROR */}
        {foundErr ? <label className="db red mt3 fw6">{foundErr}</label> : null}
      </div>

      {/* MONTHLY TOTALS */}
      <div className="rc-totals">
        {Object.entries(monthlyTotals).map(([key, total]) => {
          const [year, monthIndex] = key.split("-");
          return (
            <div key={key} className="rc-total">
              <p className="rc-total-title">Total Monthly Records</p>
              <div className="rc-total-month">
                {moment().month(Number(monthIndex)).format("MMMM")} {year}
              </div>
              <div className="rc-total-value">{Number(total).toFixed(2)} kg</div>
            </div>
          );
        })}
      </div>

      {/* LEGEND */}
      <ul className="rc-legend">
        {Object.entries(productColors).map(([name, color]) => (
          <li key={name}>
            <i style={{ background: color }} />
            {name}
          </li>
        ))}
      </ul>

      {/* CALENDAR */}
      <Calendar
        className="rc-calendar"
        localizer={localizer}
        events={calendarEvents}
        startAccessor="start"
        endAccessor="end"
        eventPropGetter={eventStyleGetter}
        components={{ event: EventLabel }}
      />

      {/* DOWNLOAD SECTION */}
      <div className="bg-near-white br3 br4-ns shadow-2 pa3 pa4-ns mb4 mb5-ns">
        <div className="flex flex-column flex-row-l items-start items-end-l justify-between">
          {/* LEFT SIDE */}
          <div className="w-100 w-70-l">
            <h3 className="f4 fw6 near-black ma0 mb3">Download Farmer Records</h3>

            <div className="flex flex-column flex-row-l flex-wrap items-start">
              {/* PERIOD SELECT */}
              <div className="mr3 mb3">
                <label className="db mb2 fw6 gray f6">Export Period</label>

                <select
                  className="pa2 br3 ba b--light-silver bg-white dark-gray outline-0 w5"
                  value={downloadPeriod}
                  onChange={(e) => setDownloadPeriod(e.target.value)}
                >
                  <option value="full">Full Records</option>
                  <option value="month">Total Monthly Records</option>
                  <option value="custom">Custom Range</option>
                </select>
              </div>

              {/* CUSTOM DATES */}
              {downloadPeriod === "custom" && (
                <>
                  <div className="mr3 mb3">
                    <label className="db mb2 fw6 gray f6">From</label>

                    <DatePicker
                      selected={customStartDate}
                      onChange={(date) => setCustomStartDate(date)}
                      placeholderText="Start Date"
                      className="pa2 br3 ba b--light-silver bg-white dark-gray outline-0 w5"
                    />
                  </div>

                  <div className="mr3 mb3">
                    <label className="db mb2 fw6 gray f6">To</label>

                    <DatePicker
                      selected={customEndDate}
                      onChange={(date) => setCustomEndDate(date)}
                      placeholderText="End Date"
                      className="pa2 br3 ba b--light-silver bg-white dark-gray outline-0 w5"
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* DOWNLOAD BUTTON */}
          <div className="mt4 mt0-l">
            <button
              onClick={handleDownloadTable}
              className="pointer bn br-pill white bg-dark-green hover-bg-green pa3 ph4 fw6 shadow-1 dim transition"
            >
              ⬇ Download PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecordsCalender;